import React, {useEffect, useMemo, useState} from 'react'
import axios from 'axios'
import {ModalDistribuidor} from '../../components/ModalDistribuidor/ModalDistribuidor'
import {Modal} from 'react-bootstrap'
import LoadingOverlay from 'react-loading-overlay'
import {AdminDataTable, AdminStatusBadge, AdminTableSearch} from '../../components/AdminDataTable/AdminDataTable'
import '../Distribuidores/Distribuidores.css'

const fields = [
  {label: 'Nombre comercial', key: 'nombre'},
  {label: 'Razón social', key: 'razonSocial', optional: true},
  {label: 'Nombre de contacto', key: 'apellido'},
  {label: 'Correo', key: 'email'},
  {label: 'Teléfono', key: 'telefono', optional: true},
  {label: 'Estatus', key: 'estatus'},
  {label: 'Fecha de alta', key: 'fechaAlta'},
]
const formatDate = (value) => {
  if (!value) return '—'
  const date = new Date(String(value).replace(' ', 'T'))
  return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat('es-MX', {dateStyle: 'medium'}).format(date)
}
const displayValue = (row, key) => key === 'fechaAlta' ? formatDate(row[key]) : row[key] || '—'

export function MisDistribuidores() {
  const [distributors, setDistributors] = useState([])
  const [detail, setDetail] = useState(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    axios.get(`${process.env.REACT_APP_API_URL}/distribuidores-vendedor`)
      .then(({data}) => {
        if (!Array.isArray(data.data)) throw new Error('Invalid distributor response')
        if (active) setDistributors(data.data)
      })
      .catch((requestError) => {
        if (active) setError(requestError.response?.data?.message || 'No fue posible consultar tus distribuidores.')
      })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [])

  const viewDetail = async (id) => {
    setLoading(true)
    setError('')
    setDetail(null)
    try {
      const {data} = await axios.get(`${process.env.REACT_APP_API_URL}/distribuidores-vendedor/${id}`)
      if (!data.data) throw new Error('Missing distributor detail')
      setDetail(data.data)
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'No fue posible consultar el detalle del distribuidor.')
    } finally {
      setLoading(false)
    }
  }

  const availableFields = fields.filter((field) => !field.optional || distributors.some((row) => Object.prototype.hasOwnProperty.call(row, field.key)))
  const visibleDistributors = useMemo(() => {
    const term = search.trim().toLocaleLowerCase('es-MX')
    return distributors.filter((row) => fields.some(({key}) => String(row[key] || '').toLocaleLowerCase('es-MX').includes(term)))
  }, [distributors, search])
  const columns = availableFields.map(({label, key}) => ({
    name: label,
    selector: (row) => row[key] || '',
    sortable: true,
    wrap: true,
    cell: (row) => key === 'estatus' ? <AdminStatusBadge status={row.estatus} /> : displayValue(row, key),
  }))
  columns.push({name: 'Acción', width: '145px', cell: (row) => <button type='button' className='btn btn-sm btn-light-primary' onClick={() => viewDetail(row.id)}>Ver detalle</button>})

  return <LoadingOverlay active={loading} spinner text='Cargando...'>
    <Modal show={Boolean(detail)} onHide={() => setDetail(null)} dialogClassName='modal-distribuidor-dialog' centered aria-labelledby='seller-distributor-detail-title'>
      <Modal.Header closeButton><Modal.Title id='seller-distributor-detail-title'>Detalle de Distribuidor</Modal.Title></Modal.Header>
      <Modal.Body>
        {detail && <ModalDistribuidor usuario={[detail]} viewOnly onClose={() => setDetail(null)} />}
      </Modal.Body>
    </Modal>
    <div className='card card-custom card-stretch shadow mb-5 admin-list-card'>
      <div className='card-header'><h3 className='card-title'>Mis distribuidores</h3></div>
      <div className='card-body'>
        {error && <div className='alert alert-danger' role='alert'>{error}</div>}
        <AdminTableSearch value={search} onChange={(event) => setSearch(event.target.value)} ariaLabel='Buscar mis distribuidores' />
        <AdminDataTable columns={columns} data={visibleDistributors} pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 25, 50, 100]} noDataComponent={error ? 'No fue posible cargar los distribuidores.' : search.trim() ? 'No hay distribuidores que coincidan con tu búsqueda.' : 'No tienes distribuidores asignados.'} />
      </div>
    </div>
  </LoadingOverlay>
}
